import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-61583e67")

_pushScopeId("data-v-61583e67")
const _hoisted_1 = {
  key: 0,
  class: "py-8"
}
const _hoisted_2 = {
  key: 1,
  class: "w-full max-h-screen"
}
const _hoisted_3 = {
  key: 0,
  class: "sticky top-0 z-20"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "flex flex-col pl-3 text-gray-lp-300 font-bold" }, [
  /*#__PURE__*/_createVNode("div", { style: {"line-height":"100%"} }, " . "),
  /*#__PURE__*/_createVNode("div", { style: {"line-height":"100%"} }, " . "),
  /*#__PURE__*/_createVNode("div", { style: {"line-height":"100%"} }, " . ")
], -1)
const _hoisted_5 = {
  class: "text-center",
  style: {"max-width":"102px"}
}
const _hoisted_6 = { class: "flex flex-row items-center gap-1 relative justify-start pl-3" }
const _hoisted_7 = {
  key: 1,
  class: "w-10 h-10 flex flex-row justify-center items-center"
}
const _hoisted_8 = { style: {"max-width":"200px"} }
const _hoisted_9 = { style: {"max-width":"176px"} }
const _hoisted_10 = { class: "flex flex-row items-center gap-1" }
const _hoisted_11 = { style: {"max-width":"78px"} }
const _hoisted_12 = { style: {"max-width":"120px"} }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { style: {"max-width":"120px"} }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createVNode("tr", { id: "infinite-scroll-bottom" }, null, -1)
const _hoisted_19 = {
  key: 1,
  class: "sticky bottom-0 z-20"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Lihat peringkat anda ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Icons = _resolveComponent("Icons")!

  return (_ctx.noConnection)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_EmptyState, {
          icon: "error-internet",
          customHeaderMessage: _ctx.$t('dashboard.leaderboard.emptyState.noConnection.header'),
          customMessage: _ctx.$t('dashboard.leaderboard.emptyState.noConnection.message'),
          buttonAction: {
        title: _ctx.$t('dashboard.leaderboard.emptyState.noConnection.button'),
        textColor: 'white',
        fontWeight: 'semibold',
        iconLeft: 'reload-white',
        sizeIcon: '12px'
      },
          onAction: _ctx.onRetry
        }, null, 8, ["customHeaderMessage", "customMessage", "buttonAction", "onAction"])
      ]))
    : (!!_ctx.tableData.length || _ctx.isLoading)
      ? (_openBlock(), _createBlock("table", _hoisted_2, [
          _createVNode("thead", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
              return (_openBlock(), _createBlock("th", {
                class: "col",
                key: `head-${index}`,
                style: {
          ...column.style,
          background: 'white'
        }
              }, _toDisplayString(_ctx.$t(`dashboard.leaderboard.columns.${column.key}`)), 5))
            }), 128))
          ]),
          _createVNode("tbody", null, [
            (!_ctx.isLoading)
              ? (_openBlock(), _createBlock("tr", _hoisted_3, [
                  (_ctx.isCurrentRankInTop && !_ctx.isCurrentRankInTopIntersecting)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        class: "jump-btn",
                        onClick: _cache[1] || (_cache[1] = () => _ctx.scrollToCurrentRank())
                      }, [
                        _createVNode(_component_Icons, {
                          name: "arrow-up-medium",
                          class: "w-4 h-4 text-white"
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard.leaderboard.jumpButtons.viewYourRank')), 1)
                      ]))
                    : (!_ctx.isNearestTopRewardIntersecting)
                      ? (_openBlock(), _createBlock("button", {
                          key: 1,
                          class: "jump-btn",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scrollToNearestTopRank && _ctx.scrollToNearestTopRank(...args)))
                        }, [
                          _createVNode(_component_Icons, {
                            name: "arrow-up-medium",
                            class: "w-4 h-4 text-white"
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard.leaderboard.jumpButtons.viewNearestTopReward')), 1)
                        ]))
                      : (!_ctx.isTopRankIntersecting)
                        ? (_openBlock(), _createBlock("button", {
                            key: 2,
                            class: "jump-btn",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.scrollToTopRank && _ctx.scrollToTopRank(...args)))
                          }, [
                            _createVNode(_component_Icons, {
                              name: "arrow-up-medium",
                              class: "w-4 h-4 text-white"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard.leaderboard.jumpButtons.viewTopRank')), 1)
                          ]))
                        : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableData, (leaderboard, index) => {
              return (_openBlock(), _createBlock("tr", {
                key: `row-${leaderboard.name}-${leaderboard.rank}`,
                class: [
          { highlight: leaderboard.isCurrentPos },
          {
            'pos-leaderboard separator':
              _ctx.tierRankEnds?.includes(leaderboard.rank) &&
              index !== _ctx.tableData.length - 1
          }
        ],
                "data-rank": leaderboard.rank,
                ref: 
          leaderboard.isCurrentPos
            ? 'infinite-scroll-current-rank'
            : leaderboard.rank === 1
            ? 'infinite-scroll-top-rank'
            : ''
        ,
                id: 
          leaderboard.isCurrentPos
            ? 'current-rank-row'
            : leaderboard.rank === 1
            ? 'top-rank-row'
            : _ctx.nextTier === leaderboard.rank
            ? `next-tier`
            : ''
        
              }, [
                (!leaderboard.cityCode)
                  ? (_openBlock(), _createBlock("td", {
                      key: 0,
                      colspan: _ctx.columns.length,
                      class: "bg-gray-lp-1200 z-0"
                    }, [
                      _hoisted_4
                    ], 8, ["colspan"]))
                  : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _createVNode("td", _hoisted_5, [
                        _createVNode("div", _hoisted_6, [
                          (leaderboard.rank < 6)
                            ? (_openBlock(), _createBlock("div", {
                                key: 0,
                                class: ["w-10 h-10 flex flex-row justify-center items-center", [
                  { badge: leaderboard.isCurrentPos && leaderboard.rank < 6 }
                ]],
                                style: {
                  backgroundImage: `url(${require(`@/app/ui/assets/svg/pos-leaderboard-badge-rank-${leaderboard.rank}.svg`)})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '50% 0',
                  backgroundSize: '40px'
                }
                              }, _toDisplayString(leaderboard.rank), 7))
                            : (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(leaderboard.rank), 1)),
                          _createVNode("div", {
                            class: ["flex flex-row items-center", [
                  { visible: leaderboard.rankDelta },
                  { invisible: !leaderboard.rankDelta }
                ]]
                          }, [
                            _createVNode(_component_Icons, {
                              name: "arrow-up-medium",
                              class: ["w-5 h-5", [
                    {
                      'text-white':
                        leaderboard.isCurrentPos &&
                        !_ctx.isRankDeltaNegative(leaderboard.rankDelta),
                      'text-green-lp-700':
                        !leaderboard.isCurrentPos &&
                        !_ctx.isRankDeltaNegative(leaderboard.rankDelta)
                    },
                    {
                      'text-white transform rotate-180':
                        leaderboard.isCurrentPos &&
                        _ctx.isRankDeltaNegative(leaderboard.rankDelta)
                    },
                    {
                      'text-red-lp-2000 transform rotate-180':
                        !leaderboard.isCurrentPos &&
                        _ctx.isRankDeltaNegative(leaderboard.rankDelta)
                    }
                  ]]
                            }, null, 8, ["class"]),
                            _createVNode("div", {
                              class: ["text-xs rounded-lg p-1 px-1.5 font-medium", [
                    {
                      'bg-green-lp-700 text-white ':
                        !leaderboard.isCurrentPos &&
                        !_ctx.isRankDeltaNegative(leaderboard.rankDelta),
                      'bg-white text-green-lp-700':
                        leaderboard.isCurrentPos &&
                        !_ctx.isRankDeltaNegative(leaderboard.rankDelta)
                    },
                    {
                      'bg-red-lp-2000 text-white':
                        !leaderboard.isCurrentPos &&
                        _ctx.isRankDeltaNegative(leaderboard.rankDelta),
                      'bg-white text-red-lp-2000':
                        leaderboard.isCurrentPos &&
                        _ctx.isRankDeltaNegative(leaderboard.rankDelta)
                    }
                  ]],
                              style: {"line-height":"100%"}
                            }, _toDisplayString(_ctx.isRankDeltaNegative(leaderboard.rankDelta) ? "-" : "+") + _toDisplayString(_ctx.toAbs(leaderboard.rankDelta)), 3)
                          ], 2)
                        ])
                      ]),
                      _createVNode("td", _hoisted_8, [
                        _createVNode("div", null, _toDisplayString(leaderboard.name), 1)
                      ]),
                      _createVNode("td", _hoisted_9, [
                        _createVNode("div", _hoisted_10, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(leaderboard.historyRank, (historyRank, i) => {
                            return (_openBlock(), _createBlock("div", {
                              key: `history-${index}-${i}`
                            }, [
                              _createVNode("div", {
                                class: ["flex flex-row justify-center items-center relative", [{ 'text-black-lp-200': leaderboard.isCurrentPos }]],
                                style: {
                    backgroundImage: `url(${require(`@/app/ui/assets/svg/pos-leaderboard-badge-rank-${historyRank.rank}.svg`)})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '50% 0px',
                    backgroundSize: '30px',
                    fontSize: '10px',
                    width: '30px',
                    height: '30px'
                  }
                              }, [
                                _createTextVNode(_toDisplayString(historyRank.rank) + " ", 1),
                                _createVNode("div", {
                                  class: ["history-rank-badge", [{ 'text-black-lp-200': leaderboard.isCurrentPos }]]
                                }, " x" + _toDisplayString(historyRank.count), 3)
                              ], 6)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createVNode("td", _hoisted_11, [
                        _createVNode("div", null, _toDisplayString(leaderboard.cityCode), 1)
                      ]),
                      _createVNode("td", _hoisted_12, [
                        (typeof leaderboard.revenue === 'number')
                          ? (_openBlock(), _createBlock("div", _hoisted_13, _toDisplayString(_ctx.formatPriceRP(leaderboard.revenue)), 1))
                          : (_openBlock(), _createBlock("div", _hoisted_14, "**********"))
                      ]),
                      _createVNode("td", _hoisted_15, [
                        (typeof leaderboard.reward === 'number')
                          ? (_openBlock(), _createBlock("div", _hoisted_16, _toDisplayString(_ctx.formatPriceRP(leaderboard.reward)), 1))
                          : (_openBlock(), _createBlock("div", _hoisted_17, "**********"))
                      ])
                    ], 64))
              ], 10, ["data-rank", "id"]))
            }), 128)),
            _hoisted_18,
            (!_ctx.isLoading)
              ? (_openBlock(), _createBlock("tr", _hoisted_19, [
                  (!_ctx.isCurrentRankInTop && !_ctx.isCurrentRankInTopIntersecting)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        class: "jump-btn bottom-0",
                        onClick: _cache[4] || (_cache[4] = () => _ctx.scrollToCurrentRank())
                      }, [
                        _createVNode(_component_Icons, {
                          name: "arrow-up-medium",
                          class: "w-4 h-4 transform rotate-180 text-white"
                        }),
                        _hoisted_20
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createBlock(_component_EmptyState, {
          key: 2,
          class: "flex-1",
          customHeaderMessage: _ctx.$t('dashboard.leaderboard.emptyState.noData.header'),
          customMessage: _ctx.$t('dashboard.leaderboard.emptyState.noData.message')
        }, null, 8, ["customHeaderMessage", "customMessage"]))
})